import type { SignalRNotification } from '../hooks/useSignalR';

export const SIGNATURE_INBOX_NOTIFICATION_TYPES = new Set([
  'SignatureRequestSent',
  'SignatureRequestRejected',
  'SignatureRequestCompleted',
  'SignatureSlaAtRisk',
  'SignatureSlaOverdue',
  'SignedDocumentPdfProcessing',
  'SignedDocumentPdfReady',
  'SignedDocumentPdfFailed',
]);

export const WORKFLOW_INBOX_NOTIFICATION_TYPES = new Set([
  'SlaAtRisk',
  'SlaOverdue',
  'DocumentInReview',
  'DocumentApproved',
  'DocumentArchived',
  'DocumentRejected',
  'StepAssigned',
  'SignaturesCollected',
  'DocumentPublished',
]);

export const INBOX_TOAST_DEBOUNCE_MS = 500;
export const INBOX_TOAST_DURATION_MS = 4000;

export function isInboxStyleNotification(notification: SignalRNotification): boolean
{
  if (notification.title === 'Workflow')
  {
    return true;
  }

  if (SIGNATURE_INBOX_NOTIFICATION_TYPES.has(notification.type))
  {
    return true;
  }

  if (WORKFLOW_INBOX_NOTIFICATION_TYPES.has(notification.type))
  {
    return true;
  }

  return false;
}

export function resolveInboxNotificationText(message: string, title: string): string
{
  const trimmedMessage = message.trim();
  if (trimmedMessage.length > 0)
  {
    return trimmedMessage;
  }

  const trimmedTitle = title.trim();
  if (trimmedTitle.length > 0)
  {
    return trimmedTitle;
  }

  return '';
}

export function buildCoalescedInboxToastMessage(pendingCount: number): string
{
  return `Você tem ${pendingCount} novas notificações. Abra o sininho para ver.`;
}

export function resolveInboxToastMessage(pendingCount: number, pendingTexts: string[]): string
{
  if (pendingCount <= 1)
  {
    const single = pendingTexts[0]?.trim() ?? '';
    if (single.length > 0)
    {
      return single;
    }

    return 'Você tem uma nova notificação. Abra o sininho para ver.';
  }

  return buildCoalescedInboxToastMessage(pendingCount);
}
